import {
  NotInterestedOutlined,
  RadioButtonUncheckedOutlined,
  SlowMotionVideoOutlined,
  TaskAltOutlined,
} from '@mui/icons-material'
import { Box, Typography } from '@mui/material'

export interface currentProcess {
  loginToUser: boolean | null
  findingUserId: boolean | null
  loginToAdmin: boolean | null
  gettingPositions: boolean | null
  creatingPosition: boolean | 'skip' | null
  invitingToOrganization: boolean | null
  acceptingInvitation: boolean | null
}

export const emptyProcess: currentProcess = {
  loginToUser: null,
  findingUserId: null,
  loginToAdmin: null,
  gettingPositions: null,
  creatingPosition: null,
  invitingToOrganization: null,
  acceptingInvitation: null,
}
const ProcessStatus = ({
  currentProcess,
}: {
  currentProcess: currentProcess
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        {currentProcess.loginToUser === null ? (
          <RadioButtonUncheckedOutlined />
        ) : currentProcess.loginToUser ? (
          <TaskAltOutlined color="success" />
        ) : (
          <NotInterestedOutlined color="error" />
        )}
        <Typography>Вход в пользователя</Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        {currentProcess.findingUserId === null ? (
          <RadioButtonUncheckedOutlined />
        ) : currentProcess.findingUserId ? (
          <TaskAltOutlined color="success" />
        ) : (
          <NotInterestedOutlined color="error" />
        )}
        <Typography> Получение пользовательских данных</Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        {currentProcess.loginToAdmin === null ? (
          <RadioButtonUncheckedOutlined />
        ) : currentProcess.loginToAdmin ? (
          <TaskAltOutlined color="success" />
        ) : (
          <NotInterestedOutlined color="error" />
        )}
        <Typography>Вход в админа организации</Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        {currentProcess.gettingPositions === null ? (
          <RadioButtonUncheckedOutlined />
        ) : currentProcess.gettingPositions ? (
          <TaskAltOutlined color="success" />
        ) : (
          <NotInterestedOutlined color="error" />
        )}
        <Typography>Получение позиций организации</Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        {currentProcess.creatingPosition === null ? (
          <RadioButtonUncheckedOutlined />
        ) : currentProcess.creatingPosition === 'skip' ? (
          <SlowMotionVideoOutlined color="disabled" />
        ) : currentProcess.creatingPosition ? (
          <TaskAltOutlined color="success" />
        ) : (
          <NotInterestedOutlined color="error" />
        )}
        <Typography>Создание позиции</Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        {currentProcess.invitingToOrganization === null ? (
          <RadioButtonUncheckedOutlined />
        ) : currentProcess.invitingToOrganization ? (
          <TaskAltOutlined color="success" />
        ) : (
          <NotInterestedOutlined color="error" />
        )}
        <Typography> Приглашение в организацию</Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        {currentProcess.acceptingInvitation === null ? (
          <RadioButtonUncheckedOutlined />
        ) : currentProcess.acceptingInvitation ? (
          <TaskAltOutlined color="success" />
        ) : (
          <NotInterestedOutlined color="error" />
        )}
        <Typography> Принятие приглашения</Typography>
      </Box>
    </Box>
  )
}

export default ProcessStatus
